import { TTicketingConfigurationNotification } from '@/features/notifications/types/notification.type';

export const DEFAULT_GENERAL_TICKETING_NOTIFICATION = {
  overall: false,
  sound: false,
  activeCount: 0,
};

export const DEFAULT_TICKETING_CONFIGURATION_NOTIFICATION: TTicketingConfigurationNotification = {
  config: {
    UPDATE_ROLE: { app: false, email: false },
    COLUMN_ADDED: { app: false },
    TICKET_MOVED: { app: false },
    COMMENT_ADDED: { app: false },
    COLUMN_DELETED: { app: false },
    COLUMN_RENAMED: { app: false },
    TICKET_CREATED: { app: false, email: false },
    TICKET_UPDATED: { app: false },
    SPACE_ADDED_USER: { app: false, email: false },
    TICKET_COMPLETED: { app: false, email: false },
    SPACE_REMOVED_USER: { app: false, email: false },
    TICKET_REMOVED_USER: { app: false, email: false },
    REMINDER_NOTIFICATION: { app: false, email: false },
    TICKET_MENTIONED_USER: { app: false, email: false },
    COMMENT_MENTIONED_USER: { app: false, email: false },
  },
  activeCount: 0,
};
